// The site's own public address: canonical URLs, JSON-LD and the share image the prerender
// resolves are all built from here, never read from `apps/website`'s own config (this module owns
// no `process.env`).
export const SITE_URL = "https://zaistev.com";
